var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 12H17M9 16H17M22 8.879C21.933 7.337 21.746 6.333 21.22 5.539C20.9208 5.08661 20.5456 4.68942 20.111 4.365C18.945 3.5 17.3 3.5 14.008 3.5H9.993C6.702 3.5 5.056 3.5 3.89 4.365C3.458 4.685 3.083 5.082 2.78 5.539C2.255 6.333 2.068 7.337 2 8.879C1.99 9.142 2.216 9.344 2.465 9.344C3.851 9.344 4.975 10.533 4.975 12C4.975 13.467 3.851 14.656 2.465 14.656C2.216 14.656 1.989 14.858 2.001 15.122C2.068 16.663 2.255 17.667 2.781 18.462C3.08025 18.914 3.45545 19.3109 3.89 19.635C5.056 20.5 6.702 20.5 9.993 20.5H14.008C17.299 20.5 18.945 20.5 20.111 19.635C20.543 19.315 20.918 18.918 21.221 18.461C21.746 17.667 21.933 16.663 22 15.121V8.879Z",
    stroke: "#626F86",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickets);
export default __webpack_public_path__ + "static/media/tickets.2ea45b9da7ded4a44d5d90f50ef210dd.svg";
export { ForwardRef as ReactComponent };